import React from "react"

import { CircularProgress } from "@mui/material"

import { Button, IButtonProps } from "@cirrus/ui-kit-ts/src/components/atoms/Button/index"

	// TODO: Make UI-kit root button support loading state
export const SubmitButton = ({isLoading, ...props}: IButtonProps & { isLoading?: boolean }) => <Button
	{...props}
	id="submitButton"
	variant="contained"
	color="success"
	startIcon={isLoading ? <CircularProgress size={26} color="inherit" /> : null}
/>